export enum TicketState {
	Legacy = 0,
	Open = 1,
	Resolved = 2,
	Closed = 3,
}
